import { skinsState } from './ggPlaySkins.js'

// Skins add-on results (frame plug-in). Settles ONCE at the end from the entered
// scorecard, over the IN players only, as a SEPARATE line on top of the Wolf
// money. Rendered alongside the main game's results + the Scats results.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }
const money = (v) => (v >= 0 ? `+$${Math.round(v)}` : `−$${Math.round(-v)}`)

export default function GSkinsResults({ game }) {
  const st = skinsState(game, 19)
  if (!st) return null
  const { rows, amount, payout, useNet, carry, double } = st
  const totalSkins = rows.reduce((a, r) => a + r.skins, 0)
  return (
    <div className="mt-4">
      <div className="text-xs font-bold uppercase tracking-wide text-gray-500 mb-1">💰 Skins — side game</div>
      <p className="text-sm text-gray-500 mb-2">${amount}/skin · {payout === 'per-player' ? 'per-player' : 'split-pot'}{carry ? (double ? ' · double-on-carry' : ' · carryover') : ' · no carry'} · lowest {useNet ? 'net ' : ''}score wins each hole · {totalSkins} skin{totalSkins === 1 ? '' : 's'} awarded.</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Player', 'Skins', 'Net'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{rows.map((r) => (
          <tr key={r.id} style={{ opacity: r.in ? 1 : 0.5 }}>
            <td style={cell}>{r.name}{!r.in ? ' (out)' : ''}</td>
            <td style={cell}>{r.skins}</td>
            <td style={cell}><b style={{ color: r.net > 0 ? '#1B7A3E' : r.net < 0 ? '#B42318' : '#374151' }}>{money(r.net)}</b></td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  )
}
